import React, { useRef, useState } from 'react';

const ImageUploader = ({ imageData, onImageSelect, onSubmit, onCancel }) => {
  const fileInputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);

  const handleFileSelect = (file) => {
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        onImageSelect(e.target.result, file);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleInputChange = (e) => {
    const file = e.target.files[0];
    handleFileSelect(file);
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileSelect(e.dataTransfer.files[0]);
    }
  };

  return (
    <div className="image-uploader">
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleInputChange}
        style={{ display: 'none' }}
      />

      {!imageData ? (
        <div
          className={`upload-area ${dragActive ? 'drag-active' : ''}`}
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
          onClick={() => fileInputRef.current?.click()}
        >
          <div className="upload-icon">
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
          </div>
          <h3>Upload Gambar Makanan</h3>
          <p>Klik atau seret gambar ke area ini</p>
          <span className="upload-hint">JPG, PNG, WebP</span>
        </div>
      ) : (
        <div className="image-preview-container">
          <div className="preview-content">
            <div className="image-preview-wrapper">
              <img src={imageData} alt="Preview gambar makanan" className="preview-image" />
              <div className="preview-overlay">
                <div className="preview-badge">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  Gambar Siap Diklasifikasi
                </div>
              </div>
            </div>

            <div className="preview-actions">
              <button className="action-btn submit-btn" onClick={onSubmit}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Submit untuk Klasifikasi
              </button>
              <button className="action-btn cancel-btn" onClick={onCancel}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
                Ubah Gambar
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .image-uploader {
          display: flex;
          flex-direction: column;
          align-items: stretch;
          justify-content: center;
          padding: 1.5rem;
          background: rgba(255, 255, 255, 0.92);
          border-radius: 16px;
          box-shadow: 0 6px 24px rgba(139, 149, 86, 0.12);
          backdrop-filter: blur(10px);
          border: 2px solid #D4CDB8;
          animation: fadeInUp 0.6s ease-out;
          position: relative;
          overflow: hidden;
          height: 100%;
          min-height: 380px;
        }

        .image-uploader::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, transparent, #8B9556, #9CAF88, #8B9556, transparent);
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .upload-area {
          width: 100%;
          flex: 1;
          padding: 3rem 2rem;
          border: 2px dashed #B8A99A;
          border-radius: 14px;
          text-align: center;
          cursor: pointer;
          transition: all 0.3s ease;
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(242, 235, 220, 0.5) 100%);
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 320px;
        }

        .upload-area:hover {
          border-color: #8B9556;
          box-shadow: 0 6px 24px rgba(139, 149, 86, 0.15);
          transform: translateY(-2px);
        }

        .upload-area.drag-active {
          border-color: #9CAF88;
          background: rgba(156, 175, 136, 0.1);
          box-shadow: 0 6px 24px rgba(139, 149, 86, 0.2);
          transform: scale(1.01);
        }

        .upload-icon {
          color: #8B9556;
          margin-bottom: 1.25rem;
          transition: transform 0.3s ease;
        }

        .upload-area:hover .upload-icon {
          transform: scale(1.08);
        }

        .upload-area h3 {
          color: #2c2c2c;
          margin-bottom: 0.5rem;
          font-size: 1.2rem;
          font-weight: 600;
          letter-spacing: 0.5px;
          font-family: 'Segoe UI', 'Georgia', serif;
        }

        .upload-area p {
          color: #6B5D4F;
          font-size: 0.9rem;
          font-family: 'Segoe UI', 'Georgia', serif;
          font-style: italic;
          margin-bottom: 0.5rem;
        }

        .upload-hint {
          font-size: 0.75rem;
          color: #A09888;
          letter-spacing: 0.5px;
        }

        /* Image Preview */
        .image-preview-container {
          width: 100%;
          animation: fadeInUp 0.5s ease-out;
        }

        .preview-content {
          display: flex;
          flex-direction: column;
          gap: 1.25rem;
        }

        .image-preview-wrapper {
          position: relative;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 6px 24px rgba(139, 149, 86, 0.18);
          border: 2px solid #8B9556;
        }

        .preview-image {
          width: 100%;
          height: auto;
          max-height: 320px;
          object-fit: contain;
          display: block;
          background: #f5f0e8;
        }

        .preview-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(to top, rgba(139, 149, 86, 0.9), transparent);
          padding: 0.85rem;
          display: flex;
          justify-content: center;
        }

        .preview-badge {
          display: flex;
          align-items: center;
          gap: 0.4rem;
          color: #FAF7F2;
          font-size: 0.85rem;
          font-weight: 500;
          font-family: 'Segoe UI', 'Georgia', serif;
        }

        .preview-actions {
          display: flex;
          gap: 0.75rem;
          justify-content: center;
        }

        .action-btn {
          display: flex;
          align-items: center;
          gap: 0.45rem;
          padding: 0.75rem 1.25rem;
          border: none;
          border-radius: 12px;
          font-size: 0.9rem;
          font-weight: 500;
          font-family: 'Segoe UI', 'Georgia', serif;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08);
        }

        .submit-btn {
          background: linear-gradient(135deg, #8B9556 0%, #7A8449 100%);
          color: #FAF7F2;
          flex: 1;
        }

        .submit-btn:hover {
          background: linear-gradient(135deg, #7A8449 0%, #6B7540 100%);
          transform: translateY(-2px);
          box-shadow: 0 5px 16px rgba(139, 149, 86, 0.3);
        }

        .cancel-btn {
          background: linear-gradient(135deg, #A67B5B 0%, #8B6B4A 100%);
          color: #FAF7F2;
        }

        .cancel-btn:hover {
          background: linear-gradient(135deg, #8B6B4A 0%, #6B4F35 100%);
          transform: translateY(-2px);
          box-shadow: 0 5px 16px rgba(166, 123, 91, 0.25);
        }

        .action-btn:active {
          transform: translateY(0);
        }

        /* Responsive - Tablet */
        @media (max-width: 768px) {
          .image-uploader {
            padding: 1.5rem;
          }

          .upload-area {
            padding: 2.5rem 1.5rem;
          }

          .upload-area h3 {
            font-size: 1.05rem;
          }

          .upload-area p {
            font-size: 0.82rem;
          }

          .upload-icon svg {
            width: 48px;
            height: 48px;
          }

          .preview-image {
            max-height: 280px;
          }
        }

        /* Responsive - Mobile */
        @media (max-width: 480px) {
          .image-uploader {
            padding: 1.25rem;
            border-radius: 14px;
          }

          .upload-area {
            padding: 2rem 1.25rem;
            border-radius: 12px;
          }

          .upload-icon svg {
            width: 40px;
            height: 40px;
          }

          .upload-area h3 {
            font-size: 0.95rem;
          }

          .upload-area p {
            font-size: 0.78rem;
          }

          .preview-image {
            max-height: 240px;
          }

          .preview-actions {
            flex-direction: column;
            gap: 0.6rem;
          }

          .action-btn {
            width: 100%;
            justify-content: center;
            padding: 0.7rem 1rem;
            font-size: 0.85rem;
          }

          .preview-badge {
            font-size: 0.78rem;
          }
        }

        @media (max-width: 360px) {
          .image-uploader {
            padding: 1rem;
          }

          .upload-area {
            padding: 1.75rem 1rem;
          }

          .upload-icon svg {
            width: 36px;
            height: 36px;
          }

          .upload-area h3 {
            font-size: 0.88rem;
          }
        }
      `}</style>
    </div>
  );
};

export default ImageUploader;
